// /plugins/bugsnag.client.js
// Drop unhandled errors that don't come from our own bundle (/_nuxt/).
// These are scripts injected by in-app browsers, extensions or page translators.
export default defineNuxtPlugin(() => {
  useBugsnag().addOnError((event) => {
    if (!event.unhandled)
      return true;

    const frames = event.errors[0]?.stacktrace ?? [];
    if (frames.length === 0)
      return true;

    return frames.some(frame => frame.file?.includes('/_nuxt/'));
  });
})
